import { ref } from 'vue';
import { defineStore } from 'pinia';
import { BootstrapColor } from '@lib/types';

interface Toast {
	id: number;
	title: string;
	message?: string;
	icon?: string;
	text_type?: BootstrapColor;
	bg_type?: BootstrapColor;
}

export const useToasterStore = defineStore({
	id: 'toaster',
	state: () => {
		return {
			toasts: ref<Toast[]>([]),
			idCounter: 0 as number,
		};
	},
	actions: {
		addToast(
			title: string,
			message: string | undefined = undefined,
			icon: string | undefined = undefined,
			text_type: BootstrapColor | undefined = undefined,
			bg_type: BootstrapColor | undefined = undefined,
			autoclose = true,
		) {
			const id = this.$state.idCounter++;
			this.$state.toasts.push({ id, title, message, icon, text_type, bg_type });

			if (autoclose) {
				setTimeout(() => {
					this.removeToast(id);
				}, 5000);
			}

			// Todo: Add bootstrap toast stuff here
			//import bootstrap from '@lib/plugins/bootstrap';
			/*const t = new bootstrap.Toast('body', {
                solid: true,
                variant: 'danger',
                autoHideDelay: 4000,
            });
            t.show();*/
		},
		// Add specific toast types
		addSuccessToast(title: string, message: string | undefined = undefined) {
			this.addToast(title, message, 'fa-check-circle', 'success', 'light');
		},
		addWarningToast(title: string, message: string | undefined = undefined) {
			this.addToast(title, message, 'fa-triangle-exclamation', 'dark', 'warning');
		},
		addErrorToast(title: string, message: string | undefined = undefined) {
			this.addToast(title, message, 'fa-exclamation-circle', 'danger', 'light');
		},
		removeToast(id: number) {
			this.$state.toasts = this.toasts.filter((toast) => toast.id !== id);
		},
		//
		addSaveSuccessToast(title: string) {
			this.addToast(title, undefined, 'fa-save', 'light', 'success');
		},
	},
});

export default useToasterStore;
